// IntroHome.jsx
import React from "react";
import "../IntroBlog.css";
import Imagens from "../../../../components/IMAGESCOMPONENT/ImageComponent";
import BlogDesc from "../../parts/blogdesc/BlogDesc";

const receitas = [
  {
    titulo: "Cheesecake fria com Calda de Frutas Vermelhas",
    descricao:
      "Cheesecake suave, coberto com calda de frutas vermelhas, a sobremesa perfeita para adoçar momentos...",
    data: "16/12/2025",
    imagem: Imagens.Receita1,
  },
  {
    titulo: "Canapé de Choripán com Vinagrete de Manga e Castanha Picante",
    descricao:
      "Canapé de Choripán com Vinagrete de Manga e Castanha Picante, a combinação perfeita de...",
    data: "15/12/2025",
    imagem: Imagens.Receita2,
  },
  {
    titulo: "Wok Asiático com Mignon Caramelizado e Stealth",
    descricao:
      "Texturas, contraste e aquele sabor agridoce que conquista logo na primeira garfada. Quer surpreender...",
    data: "15/12/2025",
    imagem: Imagens.Receita3,
  },
  {
    titulo: "Picanha na parrilla com purê de abóbora e batata rústica",
    descricao:
      "A ideia deste prato é deixar elegante, requintado e sofisticado. Uma apresentação bem gourmet.",
    data: "15/12/2025",
    imagem: Imagens.Receita4,
  },
  {
    titulo: "Ceviche de Camarão com Pistache",
    descricao:
      "Uma entrada leve, elegante e cheia de textura pra impressionar em qualquer ocasião. Já...",
    data: "15/12/2025",
    imagem: Imagens.Receita2,
  },
];

const IntroHome = ({ irParaAba, setDetalhesGerais }) => {
  return (
    <div className="intro-blog-wrapper">
      <div className="intro-blog-container">
        <div className="intro-blog-main">
          {/* Sidebar */}
          <aside className="intro-blog-sidebar">
            <h3 className="sidebar-title">RECEITAS</h3>
            <p className="sidebar-text">
              Saiba as principais tendências e dicas do universo food service com a{" "}
              <strong className="brand-highlight">Eliandro Alimentos</strong>
            </p>
            <img src={Imagens.Logo} alt="Logo Eliandro Alimentos" className="sidebar-logo" />
          </aside>

          {/* Lista de Receitas */}
          <div className="intro-blog-left">
            {receitas.map((receita, index) => (
              <div key={index} className="receita-item">
                <img src={receita.imagem} alt={receita.titulo} className="receita-imagem" />
                <div className="receita-conteudo">
                  <h3 className="receita-titulo">{receita.titulo}</h3>
                  <p className="receita-descricao">{receita.descricao}</p>
                  <div className="receita-rodape">
                    <span className="receita-data">{receita.data}</span>
                    <button
                      className="ler-mais"
                      onClick={() => {
                        irParaAba("Receitas");
                        setDetalhesGerais(true);
                      }}
                    >
                      LER MAIS
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* VER MAIS */}
        <div className="carregar-mais">
          <span>VER MAIS</span>
        </div>

        {/* Destaques */}
        <div className="intro-blog-right">
          <h2>Confira nossos conteúdos</h2>
          <div className="destaques">
            <div className="destaque-item" onClick={() => irParaAba("RECEITAS")}>
              <img src={Imagens.Receita1} alt="Receitas" className="destaque-imagem" />
              <h4>RECEITAS</h4>
              <p>Confira as melhores Receitas para os produtos que você encontra na Eliandro Alimentos.</p>
              <span>16/12/2025</span>
              <button className="ler-mais" onClick={() => setDetalhesGerais(true)}>
                Ler mais
              </button>
            </div>

            <div className="destaque-item" onClick={() => irParaAba("CORTES DE CARNE")}>
              <img src={Imagens.Cortes} alt="Cortes de Carne" className="destaque-imagem" />
              <h4>CORTES DE CARNE</h4>
              <p>
                Explore os diferentes cortes de carne bovina, suína e de aves, com nomes e categorias para facilitar
                a escolha do melhor corte para suas receitas.
              </p>
              <span>16/12/2025</span>
              <button className="ler-mais">Ler mais</button>
            </div>

            <div className="destaque-item" onClick={() => irParaAba("GUIAS")}>
              <img src={Imagens.Guias} alt="Guias" className="destaque-imagem" />
              <h4>GUIAS</h4>
              <p>
                Encontre guias práticos, planilhas e materiais úteis para facilitar seu dia a dia e otimizar seu
                negócio.
              </p>
              <span>16/12/2025</span>
              <button className="ler-mais">Ler mais</button>
            </div>

            <div className="destaque-item" onClick={() => irParaAba("DICAS")}>
              <img src={Imagens.Dicas} alt="Dicas" className="destaque-imagem" />
              <h4>DICAS</h4>
              <p>
                Descubra truques, curiosidades e informações úteis para aproveitar melhor os ingredientes, melhorar
                suas receitas e tornar sua experiência na cozinha ainda mais prática e saborosa.
              </p>
              <span>16/12/2025</span>
              <button className="ler-mais">Ler mais</button>
            </div>
          </div>
        </div>
      </div>

      <BlogDesc />

      {/* Banner do Blog */}
      <div className="blog-banner">
        <img src={Imagens.BlogBanner} alt="Banner do Blog" className="banner-img" />
      </div>
    </div>
  );
};

export default IntroHome;
